/* eslint-disable no-restricted-syntax */
const evaluateRule = require('./evaluateRule');
const { fieldKey } = require('../fieldVisibility');

function getFormDisplayState(form, values) {
  const displayState = {
    fieldRefs: {},
  };

  for (const group of form.items) {
    const groupKey = `group_${group.id}`;
    displayState[groupKey] = {
      id: group.id,
      isVisible: true,
    };

    if (group.isConditional) {
      displayState[groupKey].isVisible = checkConditionalState(
        displayState,
        values,
        group.visibility,
        group.matches,
        group.rules,
      );
    }

    for (const field of group.fields) {
      // The one definition of the key, shared with the predicates that read this state back.
      const key = fieldKey(field);

      displayState[key] = {
        id: field.id,
        fieldId: field.id,
        groupKey,
        isVisible: displayState[groupKey].isVisible,
      };

      if (displayState[key].isVisible && field.isConditional) {
        displayState[key].isVisible = checkConditionalState(
          displayState,
          values,
          field.visibility,
          field.matches,
          field.rules,
        );
      }

      displayState.fieldRefs[field.name] = displayState[key].isVisible;
    }
  }

  return displayState;
}

function checkConditionalState(displayState, values, visibility, matches, rules) {
  const ruleMatches = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const rule of rules) {
    // A rule pointing at a field that is itself hidden can never match
    if (displayState.fieldRefs[rule.field] === false) {
      ruleMatches.push(false);
      // eslint-disable-next-line no-continue
      continue;
    }

    const value = values[values.field_name_refs[rule.field]];
    ruleMatches.push(evaluateRule(value, rule));
  }

  if (matches === 'all') {
    const matchesAll = !ruleMatches.some((m) => !m);
    return visibility === 'hide' ? !matchesAll : matchesAll;
  }

  const matchesAny = ruleMatches.some((m) => m);
  return visibility === 'hide' ? !matchesAny : matchesAny;
}

module.exports = getFormDisplayState;
